module.exports = __webpack_public_path__ + "img/logo-horizontal-dark-wt-wm-slot.5b02fd0a.png";